import React, { useRef, useState, useEffect } from 'react';
import TablaUsuarios from './tablaUsurios';

export const Usuario = (props) => {

    return (
        <div className='container-fluid rounded p-0 m-0'>
           <div className='container-fluid w-100 h-100 p-0 m-0'>
               <TablaUsuarios/>
           </div>

        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/usuarios.js